import React, { FC, ReactElement, Ref, useRef, useState } from 'react'
import { PopperPlacementType } from '@material-ui/core'
import { ReactState } from '../../Types/Types'
import Icon from '../Icon'
import { IconName } from '../../../../NonReact/constants/React/Icon/Constants'
import PopperBubble from '../PopperBubble'

type Props = {
    className?: string
    iconName: IconName
    children?: ReactElement
    placement?: PopperPlacementType
}

export const IconPopper: FC<Props> = ({ className, iconName, children, placement }: Props): ReactElement => {
    const iconRef: Ref<HTMLDivElement> = useRef(null)
    const [open, setOpen]: ReactState<boolean> = useState<boolean>(false)

    return (
        <div className='icon-popper-container'>
            <div
                className='ip-mouse-over-area'
                onMouseOver={(): void => setOpen(true)}
                onMouseOut={(): void => setOpen(false)}
            >
                <Icon inputRef={iconRef} iconName={iconName} />
            </div>

            <PopperBubble
                className={`ip-popper ${className}`}
                content={<>{children}</>}
                anchorEl={iconRef.current}
                placement={placement ?? 'top'}
                open={open}
                infoMode
            />
        </div>
    )
}
